<template>
    <div>
        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;">
                <b>工艺列表</b>
            </p>

            <span>BOM大类</span>
            <!-- <el-select v-model="orderSearchValue" filterable remote reserve-keyword placeholder="请输入模具编号"
                :remote-method="searchOrder" :loading="loading" @change="selectOrder">
                <el-option v-for="item in queryOrderList" :key="item.value" :label="item.moldCode" :value="item">
                </el-option>
            </el-select> -->
            <div style="display:inline-block;width: 400px;">
                <el-input placeholder="请输入模具编号/产品名称" v-model="queryValue" class="input-with-select">
                    <el-select v-model="bomBigType" slot="prepend" placeholder="请选择" @change="selectOrder"
                        style="width:110px">
                        <el-option label="产品设计" value="0"></el-option>
                        <el-option label="模具设计" value="1"></el-option>
                        <el-option label="模芯" value="2"></el-option>
                        <el-option label="模架" value="3"></el-option>
                        <el-option label="全部" value="-1"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="searchProcess"></el-button>
                </el-input>
            </div>

            <!-- <span>-配件编号</span> -->
            <!-- <el-select v-model="form.sparePartCode" filterable remote reserve-keyword placeholder="请输入配件编号"
                :remote-method="searchOrder" :loading="loading" @change="selectBOM">
                <el-option v-for="item in bomList" :key="item.value" :label="item.sparePartCode" :value="item">
                </el-option>
            </el-select> -->
        </div>

        <el-table :data="processList" style="width: 100%" tooltip-effect="dark">
            <el-table-column type="index" min-width="3%" fixed>
            </el-table-column>

            <el-table-column prop="moldCode" label="归属模具" min-width="15%">
            </el-table-column>
            <el-table-column prop="sparePartCode" label="配件编号" min-width="15%">
            </el-table-column>

            <el-table-column prop="processName" label="工艺名称" min-width="20%">
            </el-table-column>

            <el-table-column prop="statusDes" label="状态" min-width="9%">
                <template slot="header">
                    <el-tooltip class="item" effect="light" placement="top" content="状态：待上机、排队中、已上机、暂停、完成">
                        <span>状态</span>
                    </el-tooltip>
                </template>
            </el-table-column>

            <el-table-column prop="createdTime" label="创建时间" min-width="11%">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="27%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" round size="small" v-if="scope.row.editable">
                        {{ scope.row.editable === true ? '编辑' : '' }}
                    </el-button>

                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="工艺详情" :visible.sync="dialogFormVisible" width="60%">
            <el-form :inline="true" :model="form">

                <el-form-item label="配件编号" required :label-width="formLabelWidth">
                    <el-input v-model="form.sparePartCode" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>
                <!-- <div style="width:350px;display: inline-block;"></div> -->

                <el-form-item label="工艺名称" required :label-width="formLabelWidth">
                    <el-input v-model="form.processName" autocomplete="off" style="width:220px"
                        :disabled="processNameDisable"></el-input>
                </el-form-item>

                <el-form-item label="状态" :label-width="formLabelWidth" v-if="statusVisible">
                    <el-radio-group v-model="form.status" style="width:570px">
                        <el-radio :label="0">待上机</el-radio>
                        <el-radio :label="1">排队中</el-radio>
                        <el-radio :label="2">已上机</el-radio>
                        <el-radio :label="3">暂停</el-radio>
                        <el-radio :label="4">完成</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:570px"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addProcess" v-show="saveButtonVisible">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "ProductionSite",
    data() {
        return {
            gc: 0,
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),
            orderSearchValue: '',
            queryOrderList: [],
            showOrderList: [],
            dialogFormVisible: false,
            saveButtonVisible: true,
            form: {
                id: '',
                moldCode: '',
                sparePartCode: '',
                processName: '',
                takeTime: '',
                status: 0,
                maker: '',
                remark: ''
            },
            formLabelWidth: '120px',
            statusVisible: false,
            bomList: [],
            processList: [],
            displayScale: 60,
            bomDivStyle: {
                display: 'inline-block',
                width: '600px',
                float: 'left'
            },
            processDivStyle: {
                display: 'inline-block',
                width: '500px',
                float: 'right'
            },
            processNameDisable: false,
            processType: 0,
            loading: false,
            bomBigType:'',
            bigTypeSearch: -1,
            queryValue: ''
        }
    },
    methods: {
        // selectClick(selection, row) {
        //     console.log('selectClick')
        // },
        // rowClick(row) {
        //     console.log('rowClick')
        // },
        searchOrder(query) {
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.queryOrder()
                }, 200);
            } else {
                this.queryOrderList = [];
            }
        },
        selectOrder(value) {
            // console.log('selectOrder')
            // console.log(value)
            this.bigTypeSearch=parseInt(value)

            // this.orderSearchValue = value.moldCode
            //this.showOrderList = []
            //this.showOrderList.push(value)
            // this.form.moldCode = value.moldCode

            this.form.sparePartCode = ''
            //this.processList = []
            // this.getAllBOM(this.bigTypeSearch)
            this.getAllProcess()
        },
        searchProcess(){
            // console.log('searchProcess')
            // console.log(this.queryValue)
            this.getAllProcess()
        },
        // selectBOM(value) {
        //     this.form.sparePartCode = value.sparePartCode
        //     this.getAllProcess()
        // },
        handleClick(row) {
            //console.log(row);
            this.form.id = row.id

            this.form.moldCode = row.moldCode
            this.form.sparePartCode = row.sparePartCode
            this.form.processName = row.processName
            this.form.status = row.status
            //console.log(this.form.status)
            this.form.remark = row.remark

            this.processNameDisable = true
            this.statusVisible = true
            this.dialogFormVisible = true
        },
        openDialog() {

            if (this.form.sparePartCode == '') {
                this.$message({
                    type: 'info',
                    message: '请先选择BOM'
                })
                return
            }

            this.form.id = ''
            //this.form.sparePartCode = ''
            this.form.processName = ''
            this.form.takeTime = ''
            this.form.status = 0
            this.form.maker = this.userId
            this.form.remark = ''

            this.processNameDisable = false
            this.statusVisible = false
            this.dialogFormVisible = true
        },
        addProcess() {
            this.$axios({
                method: "post",
                url: "/shiro/process/add",
                data: {
                    id: this.form.id,
                    moldCode: this.form.moldCode,
                    sparePartCode: this.form.sparePartCode,
                    processName: this.form.processName,
                    // takeTime: this.form.takeTime,
                    processType: this.processType,
                    status: this.form.status,
                    maker: this.form.maker,
                    remark: this.form.remark,

                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.dialogFormVisible = false
                
                this.getAllProcess()
            })
        },
        getAllProcess() {
            this.$axios({
                method: "post",
                url: "/shiro/process/getAll",
                data: {
                    moldCode: this.queryValue,
                    sparePartCode: this.form.sparePartCode,
                    processType: this.processType,
                    bomBigType:this.bigTypeSearch,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.processList = data.data
                for (let i in this.processList) {

                    this.processList[i].createdTime = this.$moment(this.processList[i].createdTime).format("YYYY-MM-DD")

                    if (this.processList[i].status == 0) {
                        this.processList[i].statusDes = '待上机'
                    } else if (this.processList[i].status == 1) {
                        this.processList[i].statusDes = '排队中'
                    } else if (this.processList[i].status == 2) {
                        this.processList[i].statusDes = '已上机'
                    } else if (this.processList[i].status == 3) {
                        this.processList[i].statusDes = '暂停'
                    } else {
                        this.processList[i].statusDes = '完成'
                    }
                }
            })
        },
        queryOrder() {

            const formData = new FormData()
            formData.append('moldCode', this.orderSearchValue)
            formData.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/mold/order/query",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                    return
                }

                this.queryOrderList = data.data
                // for (let i in this.queryOrderList) {

                //     this.queryOrderList[i].deliveryTime = this.$moment(this.queryOrderList[i].deliveryTime).format("YYYY-MM-DD")

                //     if (this.queryOrderList[i].status == 0) {
                //         this.queryOrderList[i].status = '待产'
                //     } else if (this.queryOrderList[i].status == 1) {
                //         this.queryOrderList[i].status = '生产中'
                //     } else if (this.queryOrderList[i].status == 2) {
                //         this.queryOrderList[i].status = '暂停'
                //     } else {
                //         this.queryOrderList[i].status = '完成'
                //     }
                // }


            })
        },
        getAllBOM(val) {
            this.$axios({
                method: "post",
                url: "/shiro/mold/bom/getAll",
                data: {
                    moldCode: this.form.moldCode,
                    bomBigType: val,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.bomList = data.data
                for (let i in this.bomList) {

                    this.bomList[i].createdTime = this.$moment(this.bomList[i].createdTime).format("YYYY-MM-DD")

                    if (this.bomList[i].status == 0) {
                        this.bomList[i].status = '待加工'
                    } else if (this.bomList[i].status == 1) {
                        this.bomList[i].status = '加工中'
                    } else if (this.bomList[i].status == 2) {
                        this.bomList[i].status = '暂停'
                    } else {
                        this.bomList[i].status = '完成'
                    }
                }

                //console.log(this.$refs.bomTable)
                //console.log(this.$refs.bomTable.tableData[0])
                
                //this.$refs.bomTable.toggleRowSelection(this.$refs.bomTable.tableData[0])
            })
        }
    },
    mounted() {
        this.queryOrder()
        //console.log('mmm')
        //console.log(this.$el.$refs)
    },
    updated() {

        var checkBoxEle = document.getElementsByClassName("el-checkbox")
        // console.log('ududud')
        // console.log(checkBoxEle)
        if (checkBoxEle.length > 0) {
            checkBoxEle[0].innerHTML = ''
        }

        //console.log(this.gc)

        // if (this.gc == 1) {
        //     if (this.$refs.moldTable != null && this.$refs.moldTable.selection.length == 0) {
        //         this.$refs.moldTable.toggleRowSelection(this.$refs.moldTable.tableData[0])
        
        
        //     }
        // }

        //checkBoxEle[2].innerHTML = ''
        // if (this.gc == 2) {
        //     checkBoxEle[2].innerHTML = ''

        //     this.$refs.bomTable.toggleRowSelection(this.$refs.bomTable.tableData[0])
        //     this.form.sparePartCode = this.$refs.bomTable.tableData[0].sparePartCode
        

        //     this.gc = 3
        // }
        // this.gc++
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.input-with-select {
    width: 400px;
}
</style>